// Pure helpers of the monthly capture period (spec 004, RF-3, RF-4, RF-14). The rule itself lives in the
// server: these only present what `GET /captura-mensual/period-status` returns.

const MONTHS_ES = [
  "enero", "febrero", "marzo", "abril", "mayo", "junio",
  "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre",
];

const MONTHLY = /^(\d{4})-(0[1-9]|1[0-2])$/;

/** "2026-09" -> "septiembre 2026"; anything that is not a `YYYY-MM` period -> "". */
export function formatPeriodLabel(period) {
  const match = typeof period === "string" ? MONTHLY.exec(period) : null;
  return match ? `${MONTHS_ES[Number(match[2]) - 1]} ${match[1]}` : "";
}

/** Month of a date in the browser's time zone, as `YYYY-MM`. Only the fallback when the server cannot say. */
export function localPeriod(date = new Date()) {
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}`;
}

/** Latest period the user may pick: only evaluators and buyers have one (RF-4); admin has none. */
export function maxPeriod(status) {
  return status && status.mode === "evaluator" && MONTHLY.test(status.max_period || "") ? status.max_period : undefined;
}

/** First period to show: the oldest pending one for an evaluator (RF-3), otherwise the current one. */
export function initialPeriod(status) {
  if (status && MONTHLY.test(status.pending_period || "")) return status.pending_period;
  if (status && MONTHLY.test(status.current_period || "")) return status.current_period;
  return localPeriod();
}

/** Keep a picked period at or below `max`; a cleared input and a missing `max` pass through. */
export function clampPeriod(period, max) {
  return max && MONTHLY.test(period || "") && period > max ? max : period;
}

/** Notice for the admin: which month the evaluation is being loaded into (RF-14). */
export function adminPeriodNotice(period) {
  const label = formatPeriodLabel(period);
  return label ? `Estás cargando la evaluación de ${label}.` : "";
}
